import { View, StyleSheet, Animated } from "react-native";
import { useEffect, useRef } from "react";
import { Colors } from "@/constants/Colors";
import { ms } from "./moderateScale";

interface SkeletonTextProps {
  lines?: number;
  height?: number;
}

export default function SkeletonText({
  lines = 4,
  height = ms(12),
}: SkeletonTextProps) {
  const fadeAnim = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    const animation = Animated.loop(
      Animated.sequence([
        Animated.timing(fadeAnim, {
          toValue: 0.7,
          duration: 800,
          useNativeDriver: true,
        }),
        Animated.timing(fadeAnim, {
          toValue: 0.3,
          duration: 800,
          useNativeDriver: true,
        }),
      ])
    );

    animation.start();

    return () => {
      animation.stop();
    };
  }, [fadeAnim]);

  return (
    <View style={styles.container}>
      {Array.from({ length: lines }).map((_, index) => (
        <Animated.View
          key={index}
          style={[
            styles.line,
            {
              opacity: fadeAnim,
              height,
              width: `${Math.random() * 40 + 60}%`,
            },
          ]}
        />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: ms(16),
    gap: ms(8),
  },
  line: {
    backgroundColor: Colors.gray4,
    borderRadius: ms(4),
  },
});
